import { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import axios from "axios"
import AppLayout from "@/components/app/AppLayout"
import { FeatureGate } from "@/components/app/FeatureGate"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select"
import { API_BASE } from "@/config/api"
import { formatDate } from "@/lib/format"
import { toast } from "sonner"

const API = API_BASE

export default function Communications() {
  const [rows, setRows] = useState([])
  const [clients, setClients] = useState([])
  const [form, setForm] = useState({ client_id: "", channel: "email", subject: "", body: "" })

  const load = () => axios.get(`${API}/communications`).then((r) => setRows(r.data)).catch(() => {})

  useEffect(() => {
    load()
    axios.get(`${API}/clients`).then((r) => setClients(r.data)).catch(() => {})
  }, [])

  const send = async () => {
    if (!form.client_id) return toast.error("Selectează un client")
    try {
      await axios.post(`${API}/communications`, { ...form, direction: "outbound" })
      toast.success("Înregistrat")
      setForm({ client_id: "", channel: "email", subject: "", body: "" })
      load()
    } catch {
      toast.error("Eșuat")
    }
  }

  return (
    <FeatureGate feature="communications">
      <AppLayout title="Comunicări">
        <p className="text-xs text-muted-foreground mb-4 max-w-lg">
          Jurnal manual — nu trimite email/SMS automat. Pentru remindere automate la programări, configurează{" "}
          <Link to="/app/reminder-rules" className="underline underline-offset-2">
            Remindere
          </Link>
          .
        </p>
        <div className="grid lg:grid-cols-2 gap-8 max-w-5xl">
          <section className="rounded-xl border border-border p-6 bg-card space-y-3">
            <h3 className="text-sm font-medium">Înregistrare comunicare</h3>
            <div>
              <Label className="text-xs">Client</Label>
              <Select value={form.client_id} onValueChange={(v) => setForm((f) => ({ ...f, client_id: v }))}>
                <SelectTrigger className="mt-1"><SelectValue placeholder="Alege client" /></SelectTrigger>
                <SelectContent>
                  {clients.map((c) => <SelectItem key={c.id} value={c.id}>{c.name}</SelectItem>)}
                </SelectContent>
              </Select>
            </div>
            <div>
              <Label className="text-xs">Canal</Label>
              <Input value={form.channel} onChange={(e) => setForm((f) => ({ ...f, channel: e.target.value }))} className="mt-1" />
            </div>
            <div>
              <Label className="text-xs">Subiect</Label>
              <Input value={form.subject} onChange={(e) => setForm((f) => ({ ...f, subject: e.target.value }))} className="mt-1" />
            </div>
            <div>
              <Label className="text-xs">Mesaj</Label>
              <Input value={form.body} onChange={(e) => setForm((f) => ({ ...f, body: e.target.value }))} className="mt-1" />
            </div>
            <Button className="rounded-full" onClick={send}>Salvează</Button>
          </section>
          <ul className="divide-y divide-border rounded-xl border border-border bg-card text-sm max-h-[480px] overflow-auto">
            {rows.map((e) => (
              <li key={e.id} className="px-4 py-3">
                <span className="text-xs text-muted-foreground">[{e.channel}] {formatDate(e.created_at)}</span>
                <p className="font-medium mt-0.5">{e.subject || "—"}</p>
              </li>
            ))}
          </ul>
        </div>
      </AppLayout>
    </FeatureGate>
  )
}
